module.exports = __webpack_public_path__ + "static/media/refresh.c98e1c22.svg";